import logo from './arzandehgold.png';
import './App.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">
      <img src="static\media/arzandehgold-back.jpg"  />
      <img src={logo} className="App-logo" alt="logo" />

        <p>
        وب سایت 'گالــری طلای ارزنـده' توسط تیم وبمسترهفت کدنویسی اختصاصی گردیده و در حال توسعه می‌باشد
        </p>
        <a
          className="App-link"
          href="https://webmaster7.ir/portfolio"
          target="_blank"
          rel="noopener noreferrer"
        >
         ©️Copyright 2024. All Rights Reserved - Design By : webmaster7.ir
        </a>
      </header>
    </div>
  );
}

export default App;
